module.exports = __webpack_public_path__ + "static/media/tabla.1fcd7e44.svg";